<template>
  <div class="tracker">
    <button class="tracker-toggle" @click="open = !open">
      {{ open ? "▲ Tracker" : "▼ Tracker" }}
    </button>
    <div v-if="open" class="tracker-body">
      <div class="tracker-grid">
        <div v-for="item in minorItems" :key="item.type" class="active">
          <!-- <span :class="{ active: item.checked }" /> -->
          <label
            :for="item.type"
            :class="[item.type, 'icon']"
            @mouseover="
              action = item.name;
              mouse = $event;
            "
            @mouseleave="action = null"
            @mousemove="hoverEvent($event)"
            ><input
              type="button"
              :id="item.type"
              class="button"
              @contextmenu="rightClick($event, item)"
              v-on:click="minorChecked(item.type, item.amount)"
            />
          </label>
        </div>
        <div v-for="item in items" :key="item.type">
          <!-- <span :class="{ active: item.checked }" /> -->
          <label
            :for="item.type"
            @mouseover="
              action = item.name;
              mouse = $event;
            "
            @mouseleave="action = null"
            :class="[item.type, 'icon', item.checked ? 'active' : 'notActive']"
            @mousemove="hoverEvent($event)"
          >
            <input
              type="checkbox"
              :id="item.type"
              v-model="item.checked"
              v-on:click="checked(item.type)"
            />
          </label>
        </div>

        <div v-for="item in visibleDna" :key="item.type">
          <label
            :for="item.type"
            class="metroidDna icon"
            :class="[item.type, 'icon', item.checked ? 'active' : 'notActive']"
            @mouseover="
              action = item.name;
              mouse = $event;
            "
            @mouseleave="action = null"
            @mousemove="hoverEvent($event)"
            ><input
              type="checkbox"
              :id="item.type"
              v-model="item.checked"
              v-on:click="dnaChecked(item.type)"
            />
            DNA {{ item.type.replace("metroidDna", "") }}
          </label>
        </div>

        <div
          class="finalBoss"
          :class="seedBeatable ? 'active' : 'notActive'"
          @mouseover="
            action = seedBeatable
              ? 'Seed beatable — Raven Beak reachable'
              : 'Seed not yet beatable';
            mouse = $event;
          "
          @mouseleave="action = null"
          @mousemove="hoverEvent($event)"
        >
          Final Boss (Raven Beak)
        </div>

        <!-- <div>
          <button class="icon" v-on:click="addMissiles(smallMissiles)">
            missile tank 2
          </button>
        </div>
        <div>
          <button class="icon" v-on:click="addMissiles(bigMissiles)">
            missiles tank 10
          </button>
        </div>
        -->
      </div>
      <span
        v-if="hoverAction"
        class="tooltip"
        :style="{
          left: mouseX + 'px',
          top: mouseY + 'px',
        }"
      >
        {{ action }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "Tracker",
  data() {
    return {
      open: false,
      action: null,
      mouse: 0,
      mouseX: 0,
      mouseY: 0,
    };
  },
  computed: {
    ...mapState(["missiles", "energyPart", "energyFull", "powerBomb"]),
    ...mapState("items", {
      items: (state) => state.items,
      minorItems: (state) => state.minorItems,
      metroidDna: (state) => state.metroidDna,
    }),
    ...mapState("logic", {
      requiredDna: (state) => state.settings?.requiredDna ?? 12,
    }),
    ...mapGetters("logic", ["seedBeatable"]),
    /**
     * Slice the full 12-slot DNA array to only show the configured required count (1–12).
     * Drives the dynamic DNA slot rendering in the tracker grid (LOG-02).
     */
    visibleDna() {
      return this.metroidDna.slice(0, this.requiredDna);
    },
    hoverAction() {
      if (this.action) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    hoverEvent(event) {
      this.mouse = event;
      this.mouseX = event.clientX - 20;
      this.mouseY = event.clientY - 30;
    },
    rightClick(event, item) {
      event.preventDefault();
      let amount = item.amount * -1;
      this.minorChecked(item.type, amount);
    },
    toggleAbility(item, route) {
      const index = item.index;
      const type = item.type;
      this.$store.dispatch("items/updateArea", {
        index,
        route,
      });
      this.$store.dispatch("items/checkProgressive", type);
    },
    // toggleAbility(logic) {
    // this.$store.dispatch("updateAbility", { logic });
    // },
    checked(name) {
      if (name === "powerBomb") {
        if (!this.items[4].checked) {
          this.toggleMinor(4, 2);
        } else {
          this.toggleMinor(4, -2);
        }
      }
      const route = this.$router.currentRoute.value.name;
      let item = this.items;
      item.find((value, index) => {
        if (value.type === name) {
          item = { type: name, index: index };
          return true;
        }
      });
      this.toggleAbility(item, route);
      // this.toggleLogic(route, item.type);
    },
    minorChecked(type, amount) {
      let item = this.minorItems;
      let i = 0;
      item.find((value, index) => {
        if (value.type === type) {
          i = index;
          return true;
        }
      });
      this.toggleMinor(i, amount);
    },
    /**
     * Toggle a Metroid DNA tracker checkbox and trigger reachability recompute (LOG-02/LOG-04).
     * toggleDna in items.js already dispatches logic/recompute after committing TOGGLE_DNA.
     * @param {string} type - e.g. "metroidDna1", "metroidDna10"
     */
    dnaChecked(type) {
      this.$store.dispatch("items/toggleDna", { type });
    },
    toggleMinor(index, amount) {
      // Route minor-item clicks to the root counters — the single source of
      // truth the logic engine reads and that persistence saves. minorItems is
      // kept only as the static button definitions (type/name/icon/amount).
      const minorToCounter = {
        smallMissiles: "missiles",
        bigMissiles: "missiles",
        energyPart: "energyPart",
        energyFull: "energyFull",
        smallPowerBomb: "powerBomb",
      };
      const minor = this.minorItems[index];
      const type = minor && minorToCounter[minor.type];
      if (!type) return;
      this.$store.dispatch("updateAbility", { amount, type });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
.tracker {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: #92a5b8;
}
.tracker-toggle {
  display: block;
  background: #0b131a;
  color: #92a5b8;
  border: 1px solid #92a5b8;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 12px;
  width: 100%;
  text-align: left;
}
.tracker-body {
  background: #0b131a;
  border: 1px solid #92a5b8;
  border-bottom: none;
  padding: 8px 12px;
  max-height: 80vh;
  overflow-y: auto;
}
.tracker-grid {
  display: grid;
  grid-template-columns: repeat(5, 50px);
  grid-auto-rows: 50px;
  text-align: left;
  color: #92a5b8;
}
.tracker-grid > div {
  box-sizing: border-box;
  border: 1px solid #92a5b8;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
}
.tracker-grid > div > label {
  cursor: pointer;
}
.icon {
  /* background-image: url("../assets/logo.png"); */
  height: 50px;
  width: 50px;
  background-size: 100%;
}
.active {
  /* border: 1px solid blue; */
  height: 100%;
  width: 100%;
  opacity: 1;
}
.notActive {
  /* border: 1px solid red; */
  height: 100%;
  width: 100%;
  opacity: 0.4;
}
.button {
  background-color: #0b131a00;
  color: white;
  width: 100%;
  height: 100;
  height: 100%;
  border: 0px;
  border-top: 1px solid;
  border-bottom: 1px solid;
}
/* .button:active {
  opacity: 0;
} */
.smallMissiles {
  background-image: url("../assets/missiles.png");
}
.smallMissiles:active,
.bigMissiles:active,
.energyPart:active,
.energyFull:active,
.smallPowerBomb:active {
  opacity: 0.5;
}
.bigMissiles {
  background-image: url("../assets/bigMissiles.png");
}
.energyPart {
  background-image: url("../assets/energyPart.png");
}
.energyFull {
  background-image: url("../assets/energyFull.png");
}
.smallPowerBomb {
  background-image: url("../assets/smallPowerBomb.png");
}
.chargeBeam {
  background-image: url("../assets/chargeBeam.png");
}

.variaSuit {
  background-image: url("../assets/variaSuit.png");
}
.morphBall {
  background-image: url("../assets/morphBall.png");
}
.bomb {
  background-image: url("../assets/bomb.png");
}
.gravitySuit {
  background-image: url("../assets/gravitySuit.png");
}
.spiderMagnet {
  background-image: url("../assets/spiderMagnet.png");
}
.grappleBeam {
  background-image: url("../assets/grappleBeam.png");
}
.phantomCloak {
  background-image: url("../assets/phantomCloak.png");
}
.diffusionBeam {
  background-image: url("../assets/diffusionBeam.png");
}
.wideBeam {
  background-image: url("../assets/wideBeam.png");
}
.speedBooster {
  background-image: url("../assets/speedBooster.png");
}
.flashShift {
  background-image: url("../assets/flashShift.png");
}
.stormMissiles {
  background-image: url("../assets/stormMissiles.png");
}
.superMissiles {
  background-image: url("../assets/superMissiles.png");
}
.pulseRadar {
  background-image: url("../assets/pulseRadar.png");
}
.iceMissiles {
  background-image: url("../assets/iceMissiles.png");
}
.crossBomb {
  background-image: url("../assets/crossBomb.png");
}
.spinBoost {
  background-image: url("../assets/spinBoost.png");
}
.waveBeam {
  background-image: url("../assets/waveBeam.png");
}
.plasmaBeam {
  background-image: url("../assets/plasmaBeam.png");
}
.spaceJump {
  background-image: url("../assets/spaceJump.png");
}
.screwAttack {
  background-image: url("../assets/screwAttack.png");
}
.slide {
  background-image: url("../assets/slide.png");
}
.powerBomb {
  background-image: url("../assets/powerBomb.png");
}
.metroidDna {
  font-size: 11px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.finalBoss {
  grid-column: 1 / -1;
  width: auto;
  height: auto;
  font-size: 11px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  padding: 6px 4px;
  box-sizing: border-box;
}
.tooltip {
  background-color: black;
  color: white;
  opacity: 1 !important;
  pointer-events: none;
  z-index: 9999;
  position: fixed;
}
div > div > .notActive > .tooltip {
  opacity: 1 !important;
}
</style>
